module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 018.b2f014c8.jpg";